import LabLandingPage from '../../components/LabLandingPage';
import { LAB_PAGES } from '../../content/labPages';

export default function LabsHubPublicPage() {
  return <LabLandingPage page={LAB_PAGES.hub} />;
}
